'use client';

import { incrementTelemetry } from 'core-events/actions';
import Link from 'next/link';
import { useSearchParams } from 'next/navigation';
import { JSX } from 'react';
import { SearchOrigins } from 'search-gateway-client';
import { AudioStockItem, getSearchUrl } from 'search-gateway-client';
import { twMerge } from 'tailwind-merge';

import { Text } from '@videoblocks/design-system';

export type AudioPlayerArtistsProps = {
    stockItem: AudioStockItem;
    className?: string;
    wrapperClassName?: string;
};

const AudioPlayerArtists = ({
    stockItem,
    className,
    wrapperClassName,
}: AudioPlayerArtistsProps): JSX.Element | null => {
    const searchParams = useSearchParams();
    const { contentType, artists } = stockItem;
    if (!artists || artists.length === 0 || contentType !== 'music') {
        return null;
    }

    const onArtistClick = () => {
        void incrementTelemetry('search.click.artistSearch');
    };

    const renderArtists = () => {
        return artists.map((artist, index) => {
            return (
                <Text key={artist.id} fontSize="sm" fontWeight="semibold" asChild>
                    <span>
                        <Link
                            href={getSearchUrl(
                                { artistIds: [artist.id], contentType, searchOrigin: SearchOrigins.STOCK_ITEM_CARD },
                                searchParams,
                            )}
                            className={twMerge('hover:underline mb-1', className)}
                            onClick={onArtistClick}
                        >
                            {artist.name || artist.alias || ''}
                        </Link>
                        {index < artists.length - 1 && <span>, </span>}
                    </span>
                </Text>
            );
        });
    };

    return (
        <div data-testid="audio-player-artists" className={twMerge('line-clamp-2 leading-none', wrapperClassName)}>
            {renderArtists()}
        </div>
    );
};

export default AudioPlayerArtists;
